import { Action } from '@ngrx/store';

export class StockActions implements Action {

    public static getNoteListDate: string = '[STOCK] getNoteListDate';
    public static getNoteListDateError: string = '[STOCK] getNoteListDateError';
    public static getNoteListDateSuccess: string = '[STOCK] getNoteListDateSuccess';

    public static getBrokageNoteOption: string = '[STOCK] getBrokageNoteOption';
    public static getBrokageNoteOptionError: string = '[STOCK] getBrokageNoteOptionError';
    public static getBrokageNoteOptionSuccess: string = '[STOCK] getBrokageNoteOptionSuccess';

    public static getBrokageNoteStock: string = '[STOCK] getBrokageNoteStock';
    public static getBrokageNoteStockError: string = '[STOCK] getBrokageNoteStockError';
    public static getBrokageNoteStockSuccess: string = '[STOCK] getBrokageNoteStockSuccess';

    public static getBrokageNoteFuture: string = '[STOCK] getBrokageNoteFuture';
    public static getBrokageNoteFutureError: string = '[STOCK] getBrokageNoteFutureError';
    public static getBrokageNoteFutureSuccess: string = '[STOCK] getBrokageNoteFutureSuccess';

    constructor(
        public type: string,
        public payload?: any,
    ) {}
}
